import React from "react"
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class EditPaintCoating extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addPaintAndCoating:
            {
                paintAndCoatingId: 0,
                name: "",
                application: "",
                location: "",
                material: "",
                remarks: "",
                quantity: "",
                unit: "",
                pchmchm: "",
                isDeleted: false,
                isUpdated: true,
                createdBy: "",
                modifiedBy: ""
            },
            paintAndCoating: []
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.PaintCoatingList) {
            state.paintAndCoating = props.PaintCoatingList;
        }
        if (props.PaintCoatingDetails) {
            state.addPaintAndCoating = props.PaintCoatingDetails;
            state.addPaintAndCoating.isUpdated = true;
        }
    }

    hideSidePanel = () => {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.goBack();
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.addPaintAndCoating[nodeName] = e.target.value;
        this.setState({});
    }

    addPaintCoatingDetails() {
        this.state.paintAndCoating.unshift(this.state.addPaintAndCoating);
        this.props.dispatch({ type: "GetPaintCoatingList", data: this.state.paintAndCoating });
        this.setState({addPaintAndCoating:
            {
                paintAndCoatingId: 0,
                name: "",
                application: "",
                location: "",
                material: "",
                remarks: "",
                quantity: "",
                unit: "",
                pchmchm: "",
                isDeleted: false,
                isUpdated: true,
                createdBy: "",
                modifiedBy: ""
            }});
        // this.hideSidePanel();
    }

    UpdatePaintCoating() {
        const { addPaintAndCoating } = this.state;
        var index = this.state.paintAndCoating.findIndex(x => x.paintAndCoatingId === addPaintAndCoating.paintAndCoatingId);
        if (index === -1) {
            // handle error
        }
        else {
            this.setState({
                paintAndCoating: [
                    ...this.state.paintAndCoating.slice(0, index),
                    Object.assign({}, this.state.paintAndCoating[index], addPaintAndCoating),
                    ...this.state.paintAndCoating.slice(index + 1)
                ]
            }, () => {
                this.props.dispatch({ type: "GetPaintCoatingSuccess", data: this.state.paintAndCoating });
                this.hideSidePanel();
            });
        }
    }

    cancel() {
        this.hideSidePanel();
    }

    render() {
        const { PaintCoatingList, EditMaterial } = this.props;
        console.log('GetPaintCoatingList', PaintCoatingList);
        return (
            <div className="row" style={{ paddingBottom: '338px' }}>
                <div className="full-height pt-3">
                    <div className="grey-bg  course-list-page">
                        <div className="panel-box  search-filter-box mb-4">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                            </button>
                            <div className="resource-list-auth-date">
                                <div className="card mt-2 MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            {EditMaterial ? "Edit " : "Add "} Paint & Coating Systems
                                        </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Application </label><br></br>
                                                <input type="text" name="application" value={this.state.addPaintAndCoating.application} onChange={e => this.handleInputChange(e)} className="form-control"></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Name </label><br></br>
                                                <input type="text" name="name" value={this.state.addPaintAndCoating.name} onChange={e => this.handleInputChange(e)} className="form-control"></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Location </label><br></br>
                                                <input type="text" name="location" value={this.state.addPaintAndCoating.location} onChange={e => this.handleInputChange(e)} className="form-control"></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Materials </label><br></br>
                                                <input type="text" name="material" value={this.state.addPaintAndCoating.material} onChange={e => this.handleInputChange(e)} className="form-control"></input>
                                            </div>
                                            <div className="col-md-12 col-sm-12">
                                                <label className="form-label">Remarks </label><br></br>
                                                <textarea className="form-control" value={this.state.addPaintAndCoating.remarks} onChange={e => this.handleInputChange(e)} name="remarks"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                          Approximate Quantity
                                        </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Quantity </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addPaintAndCoating.quantity} onChange={e => this.handleInputChange(e)} name="quantity"></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Unit </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addPaintAndCoating.unit} onChange={e => this.handleInputChange(e)} name="unit"></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">PCHM / CHM </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addPaintAndCoating.pchmchm} onChange={e => this.handleInputChange(e)} name="pchmchm"></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 search-filter-box mt-2">
                                        <div className=" search-btn-col" style={{ textAlign: "end" }}>
                                            {!EditMaterial ?
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.addPaintCoatingDetails()}
                                                >
                                                    {" "}Add{" "}
                                                </button>
                                                :
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.UpdatePaintCoating()}
                                                >
                                                    {" "}Update{" "}
                                                </button>
                                            }
                                            <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                type="button" onClick={() => this.cancel()}
                                            >
                                                {" "}Cancel{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        ShowSidePan: state.SidePanReducer.sidePan || false,
        PaintCoatingList: state.MMPLDashboardReducer.PaintCoatingList || [],
        EditMaterial: state.MasterScreenReducer.EditMaterial,
        PaintCoatingDetails: state.MasterScreenReducer.PaintCoatingDetails
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditPaintCoating));